import type { InlineMessageHeadingLevel } from '@ingka/inline-message';
import type { AssetArticle } from '@repo/types/asset';
import { Heading } from '@repo/ui/typography';

import { BASE_CARD_HEADING_LEVEL } from '../article-card.utils';

import styles from './styles.module.scss';

interface Props {
    item: AssetArticle;
    headingLevel?: InlineMessageHeadingLevel;
}

export const ArticleCardTextLine = ({ item, headingLevel = BASE_CARD_HEADING_LEVEL }: Props) => {
    return (
        <div className={styles.article_table_row_textline} data-testid="article-card-textline">
            <Heading headingLevel={headingLevel} headingSize="xs">
                {item.name}
            </Heading>
        </div>
    );
};
